import React, { useCallback, useContext } from 'react';

import { Box } from '@mui/material';
import DocumentView from 'app/shared/components/document/DocumentView';
import PropTypes from 'prop-types';

import { getFileDateTimeName } from 'utils/file';
import { downloadOrShareBlob } from 'utils/nativeFile';

import {
  PDF_DOWNLOAD_FILE_NAME,
  PDF_FILE_EXTENSION,
  PDF_VIEWER_DOC_ID,
} from '../../FormChangeHistory.constants';
import { FormTemplateRequestsContext } from '../../FormChangeHistory.context';

import { pdfViewStyles } from './TemplatePdfView.styles';

/** One side's uploaded PDF in the shared document viewer, read with the bearer header. */
const TemplatePdfView = ({ auditId, side }) => {
  const requests = useContext(FormTemplateRequestsContext);

  const getDocumentCall = useCallback(
    () => requests.getFile(auditId, side),
    [requests, auditId, side],
  );

  const onDownloadDocument = useCallback(
    () =>
      requests.getFile(auditId, side).then(({ data }) =>
        downloadOrShareBlob(
          data,
          getFileDateTimeName({
            fileName: PDF_DOWNLOAD_FILE_NAME[side],
            extension: PDF_FILE_EXTENSION,
          }),
        ),
      ),
    [requests, auditId, side],
  );

  return (
    <Box sx={pdfViewStyles}>
      <DocumentView
        isDownloadable
        isRestrictedFunctionality
        isView
        docId={`${PDF_VIEWER_DOC_ID}-${auditId}-${side}`}
        getDocumentCall={getDocumentCall}
        isControlVisible={false}
        onDownloadDocument={onDownloadDocument}
      />
    </Box>
  );
};

TemplatePdfView.propTypes = {
  auditId: PropTypes.string.isRequired,
  side: PropTypes.string.isRequired,
};

export default TemplatePdfView;
